import { TileLayer } from '@deck.gl/geo-layers/typed';
import { BitmapLayer } from '@deck.gl/layers/typed';
import { getTileSublayerBbox } from 'app/helpers';
import { useAppSelector } from 'app/store/store';

export const useLayerTileAnalytics = (isAnalyticsMode: boolean, analyticsMode: string) => {

  if (analyticsMode === 'dynamic') return null;

  const { baseurl } = window._env_?.ANALYTICS_CONFIG ? JSON.parse(window._env_.ANALYTICS_CONFIG) : '';
  const periodFetch = useAppSelector((state) => state.facadeSlice.anlyticsFilter.period);
  const shipType = useAppSelector((state) => state.facadeSlice.anlyticsFilter.shipType);
  const url = `https://${baseurl}/map/styles/${periodFetch}_${shipType}_ANALYTICS/{z}/{x}/{y}.webp`;
  const analyticsTileLayer = new TileLayer({
    data: url,
    id: 'layer-tile-analytics',
    minZoom: 0,
    maxZoom: 19,
    tileSize: 256,

    renderSubLayers: (props) => {
      const bounds = getTileSublayerBbox(props.tile);
      if (!props.data) {
        return null;
      }
      return new BitmapLayer(props, {
        data: undefined,
        image: props.data,
        bounds,
      });
    },
    visible: isAnalyticsMode,
  });
  return  isAnalyticsMode ? analyticsTileLayer : null;
};
